import { SIDENAV_TOKENS } from '@app/components/layout/sidenav/sidenav-tokens';
import { Box, Skeleton } from '@mui/material';

/** Row count for the loading skeleton; empty state matches this height to avoid jump. */
export const NOTIFICATION_FEED_SKELETON_COUNT = 2;

/**
 * Placeholder rows that mirror NotificationFeedItemView while the feed loads,
 * including the left severity ribbon gutter.
 */
export function NotificationFeedListSkeleton({
  count = NOTIFICATION_FEED_SKELETON_COUNT,
}: {
  count?: number;
}) {
  const { activeAccentWidth, activeAccentInsetX, activeAccentInsetY, activeAccentRadius } =
    SIDENAV_TOKENS;

  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            position: 'relative',
            pl: 2,
            pr: 1,
            py: 1.25,
            borderBottom: 1,
            borderColor: 'divider',
            // Same left ribbon geometry as NotificationFeedItemView (muted grey while loading).
            '&::before': {
              content: '""',
              position: 'absolute',
              top: activeAccentInsetY,
              bottom: activeAccentInsetY,
              left: activeAccentInsetX,
              width: activeAccentWidth,
              borderRadius: `${activeAccentRadius}px`,
              bgcolor: 'grey.300',
              pointerEvents: 'none',
            },
          }}
        >
          <Skeleton width="40%" height={14} />
          <Skeleton width="75%" height={20} sx={{ mt: 0.25 }} />
          <Skeleton width="90%" height={14} sx={{ mt: 0.5 }} />
          <Skeleton width={72} height={14} sx={{ mt: 0.5 }} />
        </Box>
      ))}
    </Box>
  );
}
